import React, { useImperativeHandle, useRef } from "react";
import { Close } from "@monta/icons";
import { Button, Modal, useModal } from "@monta/design-system";
import styles from "./ConfirmationModal.module.scss";

export type TRejectionModalRef = {
  open: (cb: () => void) => void;
};

const RejectionModal = React.forwardRef<TRejectionModalRef>((props, ref) => {
  const controller = useModal();
  const callbackRef = useRef<() => void>();

  useImperativeHandle(ref, () => ({
    open(cb) {
      callbackRef.current = cb || controller.close;
      controller.open();
    }
  }));

  return (
    <Modal {...controller} className={styles["modal"]}>
      <div>
        عدم تائید منتا <Close onClick={controller.close} color="#8C8787" />
      </div>
      <p>آیا از عدم تائید آزمون اطمینان دارید؟</p>
      <Button
        onClick={() => {
          callbackRef.current?.();
          controller.close();
        }}
      >
        تایید
      </Button>
    </Modal>
  );
});

export default RejectionModal;
RejectionModal.displayName = "RejectionModal";
